const DEFAULT_PRODUCTION_SITE_URL = "https://imalandia.com";
const DEFAULT_STAGING_SITE_URL = "https://imalandia.es";
const DEFAULT_LOCAL_SITE_URL = "http://localhost:3000";
const DEFAULT_LOCAL_API_URL = "http://localhost:8888/app-test";
const DEFAULT_STAGING_API_URL = "https://imalandia.es/app-test";

const hostname =
  typeof window !== "undefined" ? window.location.hostname : "";

export const IS_LOCAL =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "";

export const IS_STAGING =
  hostname === "imalandia.es" || hostname === "www.imalandia.es";

export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (IS_LOCAL
    ? DEFAULT_LOCAL_SITE_URL
    : IS_STAGING
      ? DEFAULT_STAGING_SITE_URL
      : DEFAULT_PRODUCTION_SITE_URL);

export const API_URL =
  process.env.REACT_APP_API_URL ||
  (IS_LOCAL
    ? DEFAULT_LOCAL_API_URL
    : IS_STAGING
      ? DEFAULT_STAGING_API_URL
      : `${SITE_URL}/app`);

export const CATALOG_URL =
  process.env.REACT_APP_CATALOG_URL || `${API_URL}/products.json`;

export const CHECKOUT_API_URL =
  process.env.REACT_APP_CHECKOUT_API_URL ||
  (IS_LOCAL ? DEFAULT_LOCAL_API_URL : API_URL);

export const WRITE_API_URL =
  process.env.REACT_APP_WRITE_API_URL || CHECKOUT_API_URL;
